import React from 'react'
import { Link } from 'react-router-dom'
import { data } from '../../../data'
import { useAuth } from '../../../hooks/useAuth'

export const AccounteMenu = () => {
  const { user, logout } = useAuth()
  return (
    <aside className="col-lg-3 col-md-4 border-end pb-5 mt-n5">
      <div className="position-sticky top-0">
        <div className="text-center pt-5">
          <div className="d-table position-relative mx-auto mt-lg-4 mb-3 text-primary fw-bold">
            {user.typeUser.charAt(0).toUpperCase() + user.typeUser.slice(1)}
          </div>
          <p className="mb-3 pb-3 text-white fw-bold">{user.nombre !== '' ? user.nombre : user.phoneNumber}</p>
          <button type="button" className="btn btn-secondary w-100 d-md-none mt-n2 mb-3" data-bs-toggle="collapse" data-bs-target="#account-menu">
            <i className="bx bxs-user-detail fs-xl me-2" />
            {data.menuAccount[user.typeUser].title}
            <i className="bx bx-chevron-down fs-lg ms-1" />
          </button>
          <div id="account-menu" className="list-group list-group-flush collapse d-md-block">
            {
              data.menuAccount[user.typeUser].options.map(option => (<MenuOptionAccount key={option.id} {...option} />))
            }

            <button onClick={() => logout()} className="list-group-item list-group-item-action d-flex align-items-center text-white ">
              <i className="bx bx-log-out fs-xl me-2 text-white" />
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </aside>
  )
}
const MenuOptionAccount = (props) => {
  const { pathname, icon, title } = props

  return (
    <Link to={pathname} className="list-group-item list-group-item-action d-flex align-items-center text-white">
      <i className={`${icon} fs-xl me-2 text-white`} />
      {title}
    </Link>
  )
}
